import { IonSegment, IonSegmentButton, IonLabel } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSegmentSelected } from "../../../store/userShow";
import { selectSegmentSelected } from "../../../store/userShow/selectors/selectSegmentSelected";
import { MessagesList } from "./MessagesList";
import { PersonalDataSection } from "./PersonalDataSection";
import { RolesList } from "./RolesList";
import { TemplatesSection } from "./TemplatesSection";
import { TodoListSection } from "./TodoListSection";

export const SegmentsSection = () => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);
  return (
    <section>
      <section className="ion-padding-horizontal">
        <IonSegment
          scrollable
          onIonChange={(e) => {
            dispatch(setSegmentSelected(e.detail.value || ""));
          }}
          value={segmentSelected}
          color="primary"
          style={{ maxWidth: "750px" }}
        >
          <IonSegmentButton value="history">
            <IonLabel>Bitácora</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="todoList">
            <IonLabel>Documentos</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="info">
            <IonLabel>Informacion General</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="templates">
            <IonLabel>Formularios</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="templates">
            <IonLabel>Visibilidad</IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </section>
      <section style={{ maxWidth: "1000px" }} className="ion-margin-top">
        {/* {segmentSelected === "info" && <InfoSection />} */}
        {segmentSelected === "history" && <MessagesList />}
        {segmentSelected === "todoList" && <TodoListSection />}
        {segmentSelected === "info" && (
          <>
            <PersonalDataSection />
            <RolesList />
          </>
        )}
        {segmentSelected === "templates" && <TemplatesSection />}
      </section>
    </section>
  );
};
